import React, { useEffect, useState, Fragment } from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, ShieldCheck, Lock, Clock } from 'lucide-react';
function useCountdown() {
  const getRemaining = () => {
    const now = new Date();
    const end = new Date();
    end.setHours(23, 59, 59, 0);
    const diff = Math.max(0, end.getTime() - now.getTime());
    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor(diff % 3600000 / 60000);
    const seconds = Math.floor(diff % 60000 / 1000);
    return {
      hours,
      minutes,
      seconds
    };
  };
  const [time, setTime] = useState(getRemaining);
  useEffect(() => {
    const id = setInterval(() => setTime(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}
const pad = (n: number) => String(n).padStart(2, '0');
export function FinalCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const includes = ['El Método Airfryer Fit de 30 Días (Ebook)', 'Plan diario y listas de compras', 'Recetario completo (Desayunos, Almuerzos, Cenas, Snacks)', 'Bonus #1: 20 Postres Proteicos', 'Bonus #2: 20 Aderezos Saludables', 'Bonus #3: Rutina de Ejercicio de 30 Días', 'Bonus #4: 20 Recetas Veganas', 'Bonus #5: 50 Recetas Keto', 'Bonus #6: 50 Recetas Sin TACC'];
  return <section id="offer" className="py-24 bg-stone-900 text-white relative overflow-hidden" data-id="element-40">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-41" />

      <div className="max-w-5xl mx-auto px-4 md:px-6 relative z-10" data-id="element-42">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-43">
          <FadeIn direction="right" data-id="element-44">
            <div data-id="element-45">
              <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6 leading-tight" data-id="element-46">
                Estás a un paso de empezar.
              </h2>
              <p className="text-xl text-stone-400 mb-8" data-id="element-47">
                Llevate el método completo + los 6 bonus exclusivos y empezá hoy
                mismo tu transformación.
              </p>

              <div className="space-y-4 mb-8" data-id="element-48">
                {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-49">
                    <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0" data-id="element-50" />
                    <span className="text-stone-300" data-id="element-51">{item}</span>
                  </div>)}
              </div>

              <div className="flex items-center gap-4 text-sm text-stone-400 bg-stone-800/50 p-4 rounded-xl border border-stone-700" data-id="element-52">
                <ShieldCheck className="w-8 h-8 text-brand-500 shrink-0" data-id="element-53" />
                <p data-id="element-54">
                  <strong className="text-white block" data-id="element-55">Acceso Inmediato</strong>
                  Recibís todo el material en tu email al instante.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" data-id="element-56">
            <div className="bg-white text-stone-900 rounded-3xl p-8 md:p-10 shadow-2xl relative" data-id="element-57">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-emerald-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider shadow-md" data-id="element-58">
                Oferta por tiempo limitado
              </div>

              {/* Countdown */}
              <div className="bg-brand-50 border border-brand-100 rounded-2xl p-4 mb-6 mt-2" data-id="element-59">
                <div className="flex items-center justify-center gap-2 text-brand-700 text-sm font-semibold mb-3" data-id="element-60">
                  <Clock className="w-4 h-4" data-id="element-61" />
                  La oferta termina en
                </div>
                <div className="flex items-center justify-center gap-2" data-id="element-62">
                  {[{
                  v: hours,
                  l: 'Hs'
                }, {
                  v: minutes,
                  l: 'Min'
                }, {
                  v: seconds,
                  l: 'Seg'
                }].map((unit, i) => <Fragment key={unit.l} data-id="element-63">
                      <div className="text-center" data-id="element-64">
                        <div className="bg-stone-900 text-white font-heading font-bold text-2xl w-14 py-2 rounded-lg tabular-nums" data-id="element-65">
                          {pad(unit.v)}
                        </div>
                        <div className="text-[10px] text-stone-500 font-bold uppercase tracking-wider mt-1" data-id="element-66">
                          {unit.l}
                        </div>
                      </div>
                      {i < 2 && <span className="text-2xl font-bold text-stone-300 pb-5" data-id="element-67">
                          :
                        </span>}
                    </Fragment>)}
                </div>
              </div>

              <div className="text-center mb-8" data-id="element-68">
                <p className="text-stone-400 line-through text-xl mb-1" data-id="element-69">
                  $29.999
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-70">
                  <span className="text-stone-500 font-medium text-2xl" data-id="element-71">$</span>
                  <span className="text-5xl md:text-6xl font-heading font-extrabold text-stone-900" data-id="element-72">
                    14.999
                  </span>
                  <span className="text-stone-500 font-medium" data-id="element-73">ARS</span>
                </div>
                <div className="inline-flex items-center gap-1.5 bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-bold mt-3" data-id="element-74">
                  Ahorrás 50% hoy
                </div>
                <p className="text-emerald-600 font-bold text-sm mt-2" data-id="element-75">
                  Pago único. Acceso de por vida.
                </p>
              </div>

              <button className="w-full bg-brand-600 hover:bg-brand-700 text-white py-5 rounded-2xl font-bold text-xl transition-all shadow-lg shadow-brand-500/30 hover:shadow-xl hover:-translate-y-1 mb-6 flex items-center justify-center gap-2" data-id="element-76">
                Quiero el método ahora
              </button>

              <div className="flex items-center justify-center gap-2 text-stone-500 text-sm mb-6" data-id="element-77">
                <Lock className="w-4 h-4" data-id="element-78" />
                Pago 100% seguro y encriptado
              </div>

              <div className="flex items-start gap-3 bg-emerald-50 border border-emerald-100 rounded-2xl p-4 mb-6" data-id="element-79">
                <ShieldCheck className="w-9 h-9 text-emerald-600 shrink-0" data-id="element-80" />
                <p className="text-sm text-stone-600" data-id="element-81">
                  <strong className="text-emerald-700 block" data-id="element-82">
                    Garantía de satisfacción de 7 días
                  </strong>
                  Si por cualquier motivo no quedás conforme, escribinos y te
                  devolvemos el 100% de tu dinero. Sin preguntas.
                </p>
              </div>

              <div className="text-center border-t border-stone-100 pt-6" data-id="element-83">
                <p className="font-heading font-bold text-xl text-stone-800 italic" data-id="element-84">
                  "Tu transformación recién comienza."
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}